import { loadMoreComponent } from "../transport/components.js";
import { ComponentError, findComponent, handleResponse, PARSER } from "./_common.js";

const COMPONENT_CLASS_NAME = ".rm-component";
const SLOT_CLASS_NAME = ".rm-slot";

function findLazyChildren(element) {
    const slots = Array.from(element.querySelectorAll(`${SLOT_CLASS_NAME}[loading="lazy"]`));
    const childrenSlots = slots.filter((slot) => slot.closest(COMPONENT_CLASS_NAME) === element);

    return childrenSlots.map((slot) => slot.dataset.slotName);
}

function parseResponse(html, componentId, lazyChildrenNames) {
    const document = PARSER.parseFromString(html, "text/html");
    const rootComponent = findComponent(document, componentId);

    const elementMap = lazyChildrenNames.reduce(function findChildren(map, name) {
        const potentialSlots = Array.from(
            document.querySelectorAll(`${SLOT_CLASS_NAME}[data-slot-name="${name}"]`)
        );

        const slot = potentialSlots.find(
            (slot) => slot.closest(COMPONENT_CLASS_NAME) === rootComponent
        );

        if (slot) {
            return { ...map, [name]: slot.cloneNode(true) };
        }

        return slot;
    }, {});

    return elementMap;
}

export async function loadLazySlots(componentId) {
    const element = findComponent(window.document, componentId);
    const lazyChildrenNames = findLazyChildren(element);

    if (lazyChildrenNames.length === 0) {
        throw new ComponentError("This component has no lazy children");
    }

    const loading = element.getAttribute("loading");
    if (loading === "eager") {
        throw new ComponentError("This component was already eagerly loaded");
    }

    const lazyDeps = element.dataset.lazyDeps;

    const response = await loadMoreComponent(componentId, lazyDeps, 1);
    handleResponse(response);
    return parseResponse(response.component_html, componentId, lazyChildrenNames);
}
